import { render, staticRenderFns } from "./OfflineRecallSendMessage.vue?vue&type=template&id=3513e00f"
import script from "./OfflineRecallSendMessage.vue?vue&type=script&lang=js"
export * from "./OfflineRecallSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports